import styled from 'styled-components';

export const ContainerInDrawer = styled.div`
  .subContainer {
    padding: 20px;
    display: flex;
    flex-direction: column;
  }
  .text {
    font-size: 13px;
    color: #374065;
    letter-spacing: 0px;
    font-weight: medium;
    font-family: Roboto;
  }
  .input {
    margin-bottom: 20px;
    font-size: 13px;
  }
  .error {
    margin-top: -5px;
    color: red;
    text-align: center;
  }
  .errorSelect {
    margin-top: 9px;
    color: red;
    width: 100%;
  }
`;

export const FormContainer = styled.div`
  .align-right {
    text-align: right;
  }
  .button-left-space {
    margin-left: 15px;
  }
  .max-content {
    width: max-content !important;
  }
  .subtitle {
    margin-top: 10px;
    margin-bottom: 15px;
    font-weight: bolder;
    font-size: 16px;
  }
  .check_box_container {
    display: flex;
    justify-content: flex-start;
  }
`;
